
import { computed, onMounted, ref } from 'vue';
import CardWithdraw, { WithdrawDetail } from '../components/card/CardWithdraw.vue';
import { affiliate } from '../apis/affiliate';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { main_wallet } from '../apis/main_wallet';
import { customer } from '../apis/customer';
import { useToast } from 'primevue/usetoast';
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';
import { CashbackResult, CommissionResult, CustomerGameDetail } from '../types/customer';
import { formatCurrency } from '../utils/currency';
import { useWebStore } from '../stores/web';
import { useConfirm } from 'primevue';
import { external } from '../apis/external';
import ConfirmDialog from 'primevue/confirmdialog'
import { transfer } from '../apis/transfer';
import { depositWithdraw } from '../apis/deposit_withdraw';
import { CheckConditionWithdrawResult } from '../types/deposit_withdraw';
import { TransferWalletResult } from '../types/transfer';
import { CheckConditionAddCreditSpecialTypeResult } from '../types/main_wallet';
import Control from '../components/navbar/Control.vue';                   // optional
import Dialog from 'primevue/dialog';
import { showVuePopup } from '../utils/showVuePopup';
import AutoPeerNameEn from './AutoPeerNameEn.vue';
import WalletWithdraw from './WalletWithdraw.vue';

export default {
	name: 'WalletWithdraw',
	methods: { formatCurrency },
	components: {
		CardWithdraw,
		ConfirmDialog,
		Accordion,
		AccordionPanel,
		AccordionHeader,
		AccordionContent,
		DataTable,
		Column,
		ColumnGroup,
		Row,
		Dialog,
	},
	setup() {
		const auth = useAuthStore();
		const { profile } = storeToRefs(auth);

		const web = useWebStore();
		const {webPermission} = storeToRefs(web);

		const confirm = useConfirm()
		// group เฉพาะ instance นี้ กัน confirm.require ไปเด้ง ConfirmDialog ของ popup ตัวอื่น
		// (ConfirmationEventBus ของ PrimeVue เป็น global singleton ที่แชร์กันทุก Vue app)
		const confirmGroup = 'walletWithdraw-' + Math.random().toString(36).slice(2, 8);
		const toast = useToast();

		const controlNavbar = ref<InstanceType<typeof Control> | null>(null);

		const visible = ref(false);

		onMounted(() => {
			auth.hydrate();
			web.hydrate();

			handleWalletUser();
			handleWalletAffiliate();
			handleWalletCommission();
			handleWalletCashback();
			handleWalletDiamond();
			handleWalletCash();

			window.addEventListener(
				"message",
				(event) => {
					handlerEvent(event);
				},
				false
			);
		});

		const iframeUrl = ref<string>('');

		const walletUser = ref<WithdrawDetail>({
			label: 'กระเป๋าหลัก',
			amount: 0,
			btnLabel: 'ถอน',
			btnDisabled: false,
			btnLoading: false,
			btnTooltip: '',
			details: [],
			loading: false,
			active: true,
		});

		const walletCash = ref<WithdrawDetail>({
			label: 'กระเป๋าพัก',
			amount: 0,
			btnLabel: 'ย้าย',
			btnDisabled: false,
			btnLoading: false,
			btnTooltip: '',
			details: [],
			loading: false,
			active: true,
		});

		const walletDiamond = ref<WithdrawDetail>({
			label: 'กระเป๋าเพชร',
			amount: 0,
			btnLabel: 'ย้าย',
			btnDisabled: false,
			btnLoading: false,
			btnTooltip: '',
			details: [],
			loading: false,
			active: true,
		});

		const walletAffiliate = ref<WithdrawDetail>({
			label: 'แนะนำเพื่อน',
			amount: profile.value?.walletAffiliate || 0,
			btnLabel: 'รับ',
			btnDisabled: true,
			btnLoading: false,
			btnTooltip: '',
			details: [],
			loading: false,
			active: true,
		});

		const walletCommission = ref<WithdrawDetail>({
			label: 'คอมมิชชั่น',
			amount: 0,
			btnLabel: 'รับ',
			btnDisabled: true,
			btnLoading: false,
			btnTooltip: '',
			details: [],
			loading: false,
			active: true,
		});

		const walletCashback = ref<WithdrawDetail>({
			label: 'แคชแบ็ค',
			amount: 0,
			btnLabel: 'รับ',
			btnDisabled: true,
			btnLoading: false,
			btnTooltip: '',
			details: [],
			loading: false,
			active: false,
		});

		const handleWalletUser = async () => {
			walletUser.value.loading = true;
			try {

				const resp = await depositWithdraw.checkConditionWithdraw()

				if (resp.code !== '0') throw new Error(resp.message)

				const result = resp.result as CheckConditionWithdrawResult

				walletUser.value.amount = result?.credit || 0;

				walletUser.value.btnDisabled = result.disableBtn;
				walletUser.value.btnTooltip = result.message;

			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletUser.value.loading = false;
			}
		};

		const handleWalletAffiliate = async () => {
			walletAffiliate.value.loading = true;
			try {
				const resp = await main_wallet.checkConditionAddCreditSpecialType();

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				const result = resp.result as CheckConditionAddCreditSpecialTypeResult;


				if (!!result.message) {
					walletAffiliate.value.btnTooltip = result.message
				}

				await auth.fetchData();
				walletAffiliate.value.amount = profile.value?.walletAffiliate || 0;

				walletAffiliate.value.btnDisabled = result.isDisableBtn;

				if (walletAffiliate.value.amount < 1) {
					walletAffiliate.value.btnTooltip = 'ยอดเงินไม่ถึงกำหนด';
					walletAffiliate.value.btnDisabled = true;
				}
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletAffiliate.value.loading = false;
			}
		};

		const handleWalletCommission = async () => {
			walletCommission.value.loading = true;
			try {
				const resp = await customer.getCommission();

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				const result = resp.result as CommissionResult;

				walletCommission.value.btnTooltip = result?.message || '';
				walletCommission.value.btnDisabled = result.isDisableBtn;

				walletCommission.value.details = Object.entries(result?.details || {}).map(([key, detail]) => detail);

				walletCommission.value.amount = result?.amount || 0;
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletCommission.value.loading = false;
			}
		};

		const handleWalletCashback = async () => {
			walletCashback.value.loading = true;
			try {
				const resp = await customer.getCashback();

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				const result = resp.result as CashbackResult;

				walletCashback.value.btnTooltip = result?.message || '';

				walletCashback.value.details = Object.entries(result?.details || {}).map(([key, detail]) => detail);

				walletCashback.value.btnDisabled = result.isDisableBtn;
				walletCashback.value.amount = result?.amount || 0;
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletCashback.value.loading = false;
			}
		};

		const handleWalletDiamond = async () => {
			walletDiamond.value.loading = true;

			try {
				if ((profile.value?.walletDiamond || 0) < 1) {
					walletDiamond.value.btnDisabled = true;
					walletDiamond.value.btnTooltip = 'ยอดเงินไม่ถึงกำหนด';
				}

				await auth.fetchData();
				console.log('handleWalletDiamond', profile.value?.walletDiamond)

				walletDiamond.value.amount = profile.value?.walletDiamond || 0;
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletDiamond.value.loading = false;
			}
		}

		const handleWalletCash = async () => {
			walletCash.value.loading = true;
			try {
				if ((profile.value?.walletCash || 0) < 1) {
					walletCash.value.btnDisabled = true;
					walletCash.value.btnTooltip = 'ยอดเงินไม่ถึงกำหนด';
				}

				await auth.fetchData();
				console.log('handleWalletCash', profile.value?.walletCash)

				walletCash.value.amount = profile.value?.walletCash || 0;
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletCash.value.loading = false;
			}
		}

		const handleWithdraw = async (walletName: string, type: number) => {

			let msg = ''
			switch (walletName) {
				case 'walletUser':
					msg = 'คุณต้องการถอนเงิน ใช่หรือไม่'
					walletUser.value.btnLoading = true;
					break;
				case 'walletDiamond':
					msg = 'คุณต้องการรับเพชร ใช่หรือไม่'
					walletDiamond.value.btnLoading = true;
					break;
				case 'walletAffiliate':
					msg = 'คุณต้องการรับแนะนำเพื่อน ใช่หรือไม่'
					walletAffiliate.value.btnLoading = true;
					break;
				case 'walletCommission':
					msg = 'คุณต้องการรับคอมมิชชั่น ใช่หรือไม่'
					walletCommission.value.btnLoading = true;
					break;
				case 'walletCashback':
					msg = 'คุณต้องการรับแคชแบ็ค ใช่หรือไม่'
					walletCashback.value.btnLoading = true;
					break;
				case 'walletCash':
					msg = 'คุณต้องการย้ายเงินกระเป๋าพัก ใช่หรือไม่'
					walletCash.value.btnLoading = true;
					break;
			}

			try {
				confirm.require({
					group: confirmGroup,
					message: msg,
					header: 'ยืนยัน',
					rejectProps: {
						label: 'ยกเลิก',
						severity: 'secondary',
						outlined: true,
						size: 'small',

					},
					acceptProps: {
						label: 'ยืนยัน',
						size: 'small',
					},
					accept: async () => {
						switch (walletName) {
							case 'walletUser':
								await handleUserWithdraw();
								break;
							case 'walletDiamond':
								await handleDiamondWithdraw();
								break;
							case 'walletAffiliate':
								await handleAffiliateWithdraw();
								break;
							case 'walletCommission':
								await handleCommissionWithdraw(type);
								break;
							case 'walletCashback':
								await handleCashbackWithdraw(type);
								break;
							case 'walletCash':
								await handleCashWithdraw();
						}
					},
				});

				await auth.fetchData();
				auth.hydrate();
			} finally {
				walletUser.value.btnLoading = false;
				walletDiamond.value.btnLoading = false;
				walletAffiliate.value.btnLoading = false;
				walletCommission.value.btnLoading = false;
				walletCashback.value.btnLoading = false;
				walletCash.value.btnLoading = false;
			}

		};

		const handleUserWithdraw = async () => {
			await auth.fetchData();

			const isAutoPeer = profile.value?.isDeposit?.isAutoPeer ?? false;
			const hasNameEn = !!profile.value?.firstNameEn && !!profile.value?.lastNameEn;

			if (isAutoPeer && !hasNameEn) {
				await showVuePopup(AutoPeerNameEn, {
					// อัปเดตชื่อ EN เสร็จแล้วเปิด popup ถอนกลับมา ไม่ถอนอัตโนมัติ
					onSuccess: () => showVuePopup(WalletWithdraw),
				}, { customClass: { htmlContainer: 'min-h-fit!' } });
				return;
			}

			await executeUserWithdraw();
		};

		const executeUserWithdraw = async () => {
			walletUser.value.loading = true;

			await auth.fetchData();

			try {
				// ถอนเฉพาะจำนวนเต็ม — เศษสตางค์ค้างไว้ในกระเป๋า ไม่ได้ถูกริบ
				// รางถอนของธนาคารรับเฉพาะบาทเต็ม เศษที่ติดไปทำให้รายการตีกลับ
				//
				// ระวัง: ยอดที่ "ส่ง" มาจาก profile.balance ซึ่งเป็นคนละตัวกับ
				// walletUser.amount ที่ "โชว์" บนปุ่ม (ตัวนั้นมาจาก
				// checkConditionWithdraw().credit) — อย่าสลับกัน
				const amount = Math.floor(profile.value?.balance || 0);

				if (amount < 1) {
					toast.add({
						severity: 'warn',
						summary: 'ถอนไม่ได้',
						detail: 'ยอดเงินไม่ถึง 1 บาท',
						life: 3000,
					});

					return;
				}

				const payload = { amount }

				const resp = await depositWithdraw.withdraw(payload)

				if (resp.code !== '0') throw new Error(resp.message)

				const result = resp.result

				if (result.isPeer2Pay) {
					iframeUrl.value = 'https://peertopay.com/?action=requestSell&amt=' + payload.amount + '&t=THBP&c=THB&embedded=true';
					visible.value = true;
				} else {
					await handleWalletUser();
					await auth.fetchData();
					toast.add({ severity: 'success', summary: 'สำเร็จ', detail: 'ถอนเงินสำเร็จ', life: 3000 });
				}
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletUser.value.loading = false;
			}
		};

		const handleAffiliateWithdraw = async () => {
			walletAffiliate.value.loading = true;

			try {
				const respPreviewTakeAffiliate = await affiliate.previewTakeAffiliateCredit();
				if (respPreviewTakeAffiliate.code !== '0') throw new Error(respPreviewTakeAffiliate.message);

				const respDepositAffiliate = await main_wallet.depositAffiliate();
				if (respDepositAffiliate.code !== '0') throw new Error(respDepositAffiliate.message);

				await handleWalletAffiliate();

				await auth.fetchData();

				toast.add({ severity: 'success', summary: respDepositAffiliate.message, detail: 'รับยอดแนะนำเพื่อนสำเร็จ', life: 3000 });
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletAffiliate.value.loading = false;
			}
		};

		const handleDiamondWithdraw = async () => {
			walletDiamond.value.loading = true;

			try {
				await handleWalletDiamond();

				await auth.fetchData();

				toast.add({ severity: 'success', summary: 'สำเร็จ', detail: 'รับยอดเพชรสำเร็จ', life: 3000 });
			} catch (error: any) {

			} finally {
				walletDiamond.value.loading = false;
			}
		}

		const handleCommissionWithdraw = async (type: number) => {
			walletCommission.value.loading = true;

			try {
				const payloadTurnOverDetail = {
					commissionType: type,
				};

				const respTurnOverDetail = await customer.getCommissionTurnOverDetail(payloadTurnOverDetail);

				if (respTurnOverDetail.code !== '0') throw new Error(respTurnOverDetail.message);

				const payloadAddCommission = {
					commissionType: type,
				}

				const respAddCommission = await main_wallet.addCommissionToProduct(payloadAddCommission);

				if (respAddCommission.code !== '0') throw new Error(respAddCommission.message);

				toast.add({ severity: 'success', summary: respTurnOverDetail.message, detail: 'รับคอมมิชชั่นสำเร็จ', life: 3000 });

				await handleWalletCommission();

				await auth.fetchData();
				auth.hydrate();
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletCommission.value.loading = false;
			}
		};

		const handleCashbackWithdraw = async (type: number) => {
			walletCashback.value.loading = true;

			try {
				const payloadTurnOverDetail = {
					cashbackType: type,
				};

				const respTurnOverDetail = await customer.getCashbackTurnOverDetail(payloadTurnOverDetail);

				if (respTurnOverDetail.code !== '0') throw new Error(respTurnOverDetail.message);

				const payloadAddCashback = {
					cashbackType: type,
				}

				const respAddCashback = await main_wallet.addCashbackToProduct(payloadAddCashback);

				if (respAddCashback.code !== '0') throw new Error(respAddCashback.message);

				toast.add({ severity: 'success', summary: respTurnOverDetail.message, detail: 'รับแคชแบ็คสำเร็จ', life: 3000 });

				await handleWalletCashback();

				await auth.fetchData();
				auth.hydrate();
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletCashback.value.loading = false;
			}
		};

		const handleCashWithdraw = async () => {
			walletCash.value.btnLoading = true;

			try {
				const respTransferWallet = await transfer.transferWallet();

				if (respTransferWallet.code !== '0') throw new Error(respTransferWallet.message)

				const resultTransferWallet = respTransferWallet.result as TransferWalletResult

				if (resultTransferWallet && resultTransferWallet.isTurn) {
					const respTransferSumTurn = await transfer.transferSumTurn({
						amount: resultTransferWallet.credit,
					});

					if (respTransferSumTurn.code !== '0') throw new Error(respTransferSumTurn.message)

					const respTransferAutoWithdraw = await transfer.transferAutoWithdraw({
						amount: resultTransferWallet.credit,
						outstanding: resultTransferWallet.outstanding || 0,
					});

					if (respTransferAutoWithdraw.code !== '0') throw new Error(respTransferAutoWithdraw.message)
				}

				await handleWalletCash();

				await auth.fetchData();

				toast.add({ severity: 'success', summary: 'สำเร็จ', detail: 'ย้ายเงินกระเป๋าพักสำเร็จ', life: 3000 });
			} catch (error) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				walletCash.value.btnLoading = false;
			}
		}

		const handlerEvent = async (e: MessageEvent) => {
			const evt = e?.data?.event;
			 if (evt === "p2p_withdraw_complete") {
				 toast.add({ severity: 'success', summary: 'สำเร็จ', detail: 'ถอนเงินสำเร็จ', life: 3000 });
				 await auth.fetchData();
			}
		};

		return {
			walletUser,
			walletCash,
			walletDiamond,
			walletAffiliate,
			walletCommission,
			walletCashback,
			handleWithdraw,
			confirmGroup,
			visible,
			iframeUrl,
		};
	},
};
